var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bc-white padding-20 br-4"},[_c('b',{staticClass:"fs-18"},[_vm._v("本地化租户")]),_c('el-divider'),_c('el-empty',{attrs:{"description":"功能开发中"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }